module.exports = __webpack_public_path__ + "static/img/featrue1.8a4541f0.jpg";